/**
 * Design-system droplist row (prototype `.sd-opt`): `#33373f` text and a `#f2f2f4` fill on hover or keyboard
 * focus only. The picked option (primary text, no fill) is drawn by `z-select-item zAppearance="ds"`.
 */
export const SVZ_OPTION_ROW_CLASSES = 'text-[#33373f] hover:bg-[#f2f2f4] hover:text-current focus-visible:bg-[#f2f2f4]';

/**
 * Design-system droplist group header (prototype `.sd-grp`): a collapse toggle with a 12px chevron,
 * `8px 10px 4px` padding, 11px/700 uppercase `#8a8f9a` with `.03em` tracking and no fill. Replaces the
 * tinted `bg-primary-100` bar the Zard select used to draw.
 */
export const SVZ_GROUP_HEADER_CLASSES =
  'flex w-full cursor-pointer select-none items-center gap-1.5 px-2.5 pb-1 pt-2 text-left ' +
  'text-[11px] leading-4 font-bold uppercase tracking-[.03em] text-[#8a8f9a]';

/**
 * Design-system droplist search box (prototype `.sd-search`): 38px tall, `#e2e8f0` 1px border, radius 8,
 * `0 10px` padding, 4px margin, a 16px `#757575` magnifier before the input.
 */
export const SVZ_SEARCH_BOX_CLASSES = 'm-1 flex h-[38px] items-center gap-2 rounded-lg border border-[#e2e8f0] px-2.5';

export type SvzSearchIconPosition = 'start' | 'end';

export const svzSearchBoxClasses = (position: SvzSearchIconPosition): string => (position === 'end' ? `${SVZ_SEARCH_BOX_CLASSES} flex-row-reverse` : SVZ_SEARCH_BOX_CLASSES);

export const svzSearchIconClasses = (position: SvzSearchIconPosition): string =>
  position === 'end' ? 'icon-size-[18px] shrink-0 text-primary' : 'icon-size-4 shrink-0 text-[#757575]';
